<script>
export default {
    name: "LoadingSpinner",
};
</script>

<template>
    <div class="flex h-screen">
        <div class="m-auto">
            <div class="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
        </div>
    </div>
</template>
